import axios from "axios";

// ----------------------------------------------------------------
// Global email-verification gate.
//
// Every authenticated call returns 403 with
//   { success:false, code:"EMAIL_NOT_VERIFIED", message:"..." }
// while the user's email is unverified. Because this can happen on ANY
// request, we force a redirect to the verify-email screen here instead of
// letting individual callers show a toast.
//
// Both the `api/axios` wrapper and `api/invoke` helpers use the default axios
// instance, so a single interceptor on `axios` covers the whole app. Callers
// still receive `error.response.data` as they do today (we re-reject so their
// own catch blocks run unchanged).
// ----------------------------------------------------------------

const VERIFY_EMAIL_PATH = "/verify-email";

// Guard so a burst of failing calls only triggers one navigation.
let redirecting = false;

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const data = error?.response?.data;
    const status = error?.response?.status;

    if (status === 403 && data?.code === "EMAIL_NOT_VERIFIED") {
      localStorage.setItem("isEmailVerified", "false");

      const alreadyOnVerify = window.location.pathname.startsWith(
        VERIFY_EMAIL_PATH
      );
      if (!redirecting && !alreadyOnVerify) {
        redirecting = true;
        window.location.assign(VERIFY_EMAIL_PATH);
      }
    }

    return Promise.reject(error);
  }
);
